export default {
  pay: "Paga",
  acceptTermsAndConditions: "Accetta termini e condizioni",
  selectYourCard: "SELEZIONA LA TUA CARTA",
  yourOrder: "IL TUO ORDINE",
  generalPlaceHolderNotes:
    "Puoi rimuovere gli ingredienti, non puoi aggiungere o modificare",
  placeholderNotesDrinks: "Commenti ...",
  placeholderNotesFood: "Commenti ...",
  total: "TOTALE:",
  totalToPay: "Totale da pagare:",
  paymentConfirmation: "Conferma di pagamento",
  paymentRequest: "Hai richiesto il pagamento di:",
  payCash: "Pagare in contanti",
  yourOrderIsInProgress: "Il tuo ordine è in corso,",
  itWillReachYou: "ti raggiungerà",
  desk: "scrivania",
  paymentMethod: "METODO DI PAGAMENTO",
  dataphone: "Dataphone",
  smartphone: "Smartphone",
  howDoYouWantToPay: "Come vuoi pagare?",
  creditOrDebitCard: "Carta di credito o di debito",
  missingPay: "Pagamento mancante:",
  petitionRejected: "Petizione respinta",
  redirectingToThePaymentprocess: "Reindirizzamento al processo di pagamento",
  addNewCard: "Aggiungi nuova carta",
  paymentMade: "Pagamento fatto",
  receiptOfYourPaymentTo: "Ricevuta del pagamento a"
};
